import create from 'zustand'
import maxBy from 'lodash/maxBy'
import { wizardsApi } from './api'

const avaStates = {
  FIRST_QUESTION: 'first_question',
  IN_PROGRESS: 'in_progress',
  RESULT: 'result'
}

export const avatarImages = {
  [avaStates.FIRST_QUESTION]: {
    image: '/static/images/robot-hi.png',
    alt: 'robot-hi'
  },
  [avaStates.IN_PROGRESS]: [
    {
      image: '/static/images/robot-thinking1.png',
      alt: 'robot-thinking'
    },
    {
      image: '/static/images/robot-thinking2.png',
      alt: 'robot-thinking'
    },
    {
      image: '/static/images/robot-thinking3.png',
      alt: 'robot-thinking'
    }
  ],
  [avaStates.RESULT]: {
    image: '/static/images/robot-recommending.png',
    alt: 'robot-recommending'
  }
}

const getAvatarImage = (avaState, selections) => {
  if (avaState === avaStates.IN_PROGRESS) {
    const numberOfInProgressImages = avatarImages[avaStates.IN_PROGRESS].length
    return avatarImages[avaState][selections.length % numberOfInProgressImages]
  }
  return avatarImages[avaState]
}

const getAvatarStatus = (screen, isLinearWizard, wizardConfig, nextScreen) => {
  if (!isLinearWizard) {
    return screen.screen_options.length ? avaStates.IN_PROGRESS : avaStates.RESULT
  }
  const lastScreenInConfig = Object.keys(wizardConfig).sort()[-1]
  return nextScreen === lastScreenInConfig ? avaStates.RESULT : avaStates.IN_PROGRESS
}

const addScreenId = (config, id) => ({ ...config, screenId: id })

export const useAvaStore = create((set, get) => ({
  wizardConfig: {},
  currentScreen: {},
  selections: [],
  currentImage: {},
  isLinearWizard: false,
  showBackButton: () => get().selections.length > 0,
  actions: {
    getByPlacement: placement => {
      wizardsApi.getByPlacement(placement).then(([wizardConfig]) => {
        set({
          wizardConfig,
          currentScreen: wizardConfig?.root_screen,
          selections: [],
          currentImage: getAvatarImage(avaStates.FIRST_QUESTION)
        })
      })
    },
    getByConfig: (config, isLinearWizard) => {
      // todo: filter firstScreen
      set({
        wizardConfig: config,
        currentScreen: addScreenId(config[0], 0),
        selections: [],
        currentImage: getAvatarImage(avaStates.FIRST_QUESTION),
        isLinearWizard
      })
    },
    nextScreen: option => {
      const { isLinearWizard, wizardConfig } = get()
      const newSelections = [...get().selections, { ...option, currentScreen: get().currentScreen }]
      set({ selections: newSelections })

      if (option.next_screen) {
        const screen = isLinearWizard
          ? addScreenId(wizardConfig[option.next_screen], option.next_screen)
          : option.next_screen

        set({
          currentScreen: screen,
          currentImage: getAvatarImage(
            getAvatarStatus(screen, isLinearWizard, wizardConfig, option.next_screen),
            get().selections
          )
        })
      } else {
        // determine final screen
        const scoresByOutcome = newSelections.reduce((acc, { outcome, number_of_points }) => {
          if (outcome && outcome.name) acc[outcome.name] = (acc[outcome.name] || 0) + number_of_points

          return acc
        }, {})

        const highestOutcomeName = maxBy(Object.keys(scoresByOutcome), outcome => scoresByOutcome[outcome])
        const outcome = get().wizardConfig.outcomes.find(x => x.name === highestOutcomeName)
        set({ currentScreen: outcome.final_screen, currentImage: getAvatarImage(avaStates.RESULT) })
      }
    },
    previousScreen: () => {
      const selections = get().selections
      const lastSelection = selections[selections.length - 1]
      set({ selections: [...selections.slice(0, selections.length - 1)], currentScreen: lastSelection.currentScreen })
      set({
        currentImage: getAvatarImage(
          get().selections.length ? avaStates.IN_PROGRESS : avaStates.FIRST_QUESTION,
          get().selections
        )
      })
    }
  }
}))
